import React, { useEffect, useState } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  useMediaQuery,
  useTheme,
  Box,
  Typography,
  IconButton,
  Button,
  TableHead,
  Modal,
  Card,
} from "@mui/material";

import './Vender.css'

import Paginations from "../../common/pagination/Paginations";
import { useNavigate } from 'react-router-dom';
import { allUserListApi, allVenderListApi, blockVenderApi, deleteVenderApi, resumeVenderApi } from '../../api';
import { useSelector } from 'react-redux';
import Loader from '../../common/loader/Loader';

import { toast } from 'react-toastify';
import AllVenderRow from '../../common/tablerow/AllVenderRow';
import TableComp from '../../common/tablecomp/TableComp';


const AllVendor = () => {
  
  const token = useSelector((state) => state?.user?.user?.token);
 
  const [venderData, setVenderData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [change,setChange]=useState(false)
  // const [open, setOpen] = useState(false);
  // const [selectedRow, setSelectedRow] = useState(null);
  const navigate = useNavigate();

  const handleClickOpen = (row) => {
    navigate(`/vender-management/vender-details/${row?._id}`, {
      state: { selectedRow: row }
    });
    // setSelectedRow(row);
    // setOpen(true);
  };

  const handlePageChange = (page) => {
    setLoading(true);
    setCurrentPage(page);
  };


  // console.log("allvendir", venderData);

  const handleAllVenderList = async () => {
    try {
      let type = 2
      setLoading(true);
      const response = await allUserListApi({ token, type, currentPage });
      setVenderData(response?.users || []);
      // console.log("usr", response);
      setCurrentPage(response?.currentPage)
      setTotalPages(response?.totalPages)
    
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  useEffect(() => {
    handleAllVenderList()
  }, [currentPage,change])


  const handleBlockVender = async (id) => {

    const isConfirmed = window.confirm("Are you sure, you want to Block this Vendor?");
    if (!isConfirmed) {
      return;
    }
    try {
      const response = await blockVenderApi({ token, id,})
      setChange(!change)
      toast.success(response?.message)
    } catch (error) {
      toast.error(error?.response?.data?.error||"Vendor not Blocked")
      console.log("error", error?.response?.data?.error);
    
    }
  }

  const handleResumeVender = async (id) => {
    
    const isConfirmed = window.confirm("Are you sure, you want to Resume this Vender?");
    if (!isConfirmed) {
      return;
    }
    try {
      const response = await resumeVenderApi( {token, id} )
      setChange(!change);
      toast.success(response?.message)
    } catch (error) {
      toast.error(error?.response?.data?.error||"Vendor not resumed")
      console.log("error", error?.response?.data?.error);
    }
  }

  const handleDeleteVender = async (id) => {

    const isConfirmed = window.confirm("Are you sure, you want to Delete this Vender?");
    if (!isConfirmed) {
      return;
    }
    try {
      const response = await deleteVenderApi({ token, id})
      setChange(!change);
      toast.success(response?.message)
    } catch (error) {
      
      toast.error(error?.message||"Vendor not deleted")
      console.log("error", error);
    }
  }

  const titles = [
    { title: "Business Name" },
    { title: "Email" },
    { title: "Mobile no" },
    { title: "Bank Details" },
    { title: "Status" },
    { title: "Address" },
    { title: "Created Date" },
    { title: "Action" },
  ];

  return (
    <div>

      {loading ? (
        <Loader variant="table" />
      ) : (
        <Card
        backgroundColor={"#fff"}
        borderRadius={"35px"}
        sx={{ padding: "20px", borderRadius: "25px",marginTop: "40px", marginBottom: "30px"  }}
      >
        <TableComp title={titles}>
          {venderData?.length > 0 ? (
            venderData?.map((item) => (
              <AllVenderRow 
                key={item?._id}
                row={item}
                handleviewMore={()=>handleClickOpen(item)}
                deleteVender={()=>handleDeleteVender(item?._id)}
                blockVender={()=>handleBlockVender(item?._id)}
                resumeVender={()=>handleResumeVender(item?._id)}
                
              />
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={titles.length} align="center">
                No Data Found
              </TableCell>
            </TableRow>
          )}
        </TableComp>

        <Paginations
         totalPages={totalPages}
         currentPage={currentPage}
         onPageChange={handlePageChange}
         disabled={loading}
        />
      </Card>
      )}
    </div>
  )
}

export default AllVendor